const productType = require('./product-type');

module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        action: {
            type: 'string'
        },
        lineId: {
            type: 'number'
        },
        id: {
            type: 'string'
        },
        sku: {
            type: 'string'
        },
        gpid: {
            type: 'string'
        },
        productId: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        parentId: {
            type: 'number'
        },
        price: {
            type: ['number', 'null']
        },
        pricing: {
            type: ['object', 'null']
        },
        quantity: {
            type: 'number'
        },
        payWithPoints: {
            type: 'boolean'
        },
        points: {
            type: 'number'
        },
        pointsUsed: {
            type: 'number'
        },
        psv: {
            type: 'number'
        },
        cv: {
            type: 'number'
        },
        sharingBonus: {
            type: 'string'
        },
        freightPromoSavings: {
            type: 'number'
        },
        productPromoSavings: {
            type: 'number'
        },
        taxBase: {
            type: 'number'
        },
        tax: {
            type: 'number'
        },
        rounding: {
            type: 'number'
        },
        taxInclusive: {
            type: 'boolean'
        },
        oneTime: {
            type: 'boolean'
        },
        discountedPrice: {
            type: 'object'
        },
        discountedPricePerQuantity: {
            type: 'array',
            items: {
                type: 'object'
            }
        },
        discountedPSV: {
            type: 'number'
        },
        discountedCV: {
            type: 'number'
        },
        lineItemMode: {
            type: 'string'
        },
        addedBySystem: {
            type: 'boolean'
        },
        availableQuantity: {
            type: 'number'
        },
        totalAvailableQuantity: {
            type: ['number', 'null']
        },
        freight: {
            type: 'number'
        },
        backOrderAvailableDate: {
            type: ['string', 'null']
        },
        backOrdered: {
            type: 'boolean'
        },
        invalidSku: {
            type: 'boolean'
        },
        grandFatheredPricing: {
            type: 'boolean'
        },
        plant: {
            type: 'string'
        },
        storageLocation: {
            type: 'string'
        },
        productType: productType,
        replacedSku: {
            type: 'string'
        },
        isExclusive: {
            type: 'boolean'
        },
        agelocmeCode: {
            type: 'string'
        },
        agelocmeLabel: {
            type: 'string'
        },
        agelocmeName: {
            type: 'string'
        }
    }
};
